import React from 'react';
import ReactDOM from 'react-dom/client';
import PublicMicrositeApp from './PublicMicrositeApp';
import './public.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PublicMicrositeApp />
  </React.StrictMode>,
);
